import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../core/url-params.model';

export class SettingsHttpUtil {

  public static prepareParamsSettings(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.email || params.email === 0) {
      urlParams.append('email', params.email);
    }
    if (params.emailVal) {
      urlParams.append('emailVal', params.emailVal);
    }
    if (params.phone || params.phone === 0) {
      urlParams.append('phone', params.phone);
    }
    if (params.phoneVal) {
      urlParams.append('phoneVal', params.phoneVal);
    }
    if (params.dueDate || params.dueDate === 0) {
      urlParams.append('dueDate', params.dueDate);
    }
    if (params.dueDateVal) {
      urlParams.append('dueDateVal', params.dueDateVal);
    }
    if (params.contractDate || params.contractDate === 0) {
      urlParams.append('contractDate', params.contractDate);
    }
    if (params.contractDateVal) {
      urlParams.append('contractDateVal', params.contractDateVal);
    }
    if (params.debt || params.debt === 0) {
      urlParams.append('debt', params.debt);
    }
    if (params.claim || params.claim === 0) {
      urlParams.append('claim', params.claim);
    }
    if (params.message || params.message === 0) {
      urlParams.append('message', params.message);
    }
    if (params.obligation || params.obligation === 0) {
      urlParams.append('obligation', params.obligation);
    }
    return urlParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/settings.util.ts